import { UnknownAction } from "@reduxjs/toolkit";
import { AddAssetToDealRoomRequest, ArrangeAssetInDealRoomRequest, AssetCatergory, CreateDealRoomErrorResponse, CreateDealRoomResponse, CreateDealRoomSectionRequest, DealRoom, DealRoomAsset, DealRoomCollaborate, DealRoomDetailsState, DealRoomEditRequest, DealRoomEditState, DealRoomEngageChatUser, DealRoomEvents, DealRoomHistory, DealRoomSectionState, DealRoomSharedCollectionsState, DealRoomSignal, DealRoomStage, DeleteDealRoomErrorResponse, DeleteDealRoomRequest, DeleteDealRoomResponse, DeleteStakeholderErrorResponse, DeleteStakeholderRequest, DeleteStakeholderResponse, FetchDealRoomActiveChatUserRequest, FetchDealRoomAssetAnalyticsResponse, FetchDealRoomAssetsErrorResponse, FetchDealRoomAssetsForSectionErrorResponse, FetchDealRoomAssetsForSectionRequest, FetchDealRoomAssetsForSectionResponse, FetchDealRoomAssetsRequest, FetchDealRoomAssetsResponse, FetchDealRoomCollaboratorsErrorResponse, FetchDealRoomCollaboratorsRequest, FetchDealRoomCollaboratorsResponse, FetchDealRoomDetailsRequest, FetchDealRoomEngageChatUsersRequest, FetchDealRoomErrorResponse, FetchDealRoomEventsErrorResponse, FetchDealRoomEventsRequest, FetchDealRoomEventsResponse, FetchDealRoomHistoryRequest, FetchDealRoomRequest, FetchDealRoomResponse, FetchDealRoomSharedAssetsErrorResponse, FetchDealRoomSharedAssetsRequest, FetchDealRoomSharedAssetsResponse, FetchDealRoomSharedCollectionsErrorResponse, FetchDealRoomSharedCollectionsRequest, FetchDealRoomSharedCollectionsResponse, FetchDealRoomSignalsRequest, FetchDealRoomSmartCardsErrorResponse, FetchDealRoomSmartCardsRequest, FetchDealRoomSmartCardsResponse, FetchDealRoomsRequest, FetchDealRoomsResponse, FetchingDealRoomActiveChatUserErrorResponse, FetchingDealRoomActiveChatUserResponse, FetchingDealRoomDetailsErrorResponse, FetchingDealRoomDetailsResponse, FetchingDealRoomEngageChatUsersErrorResponse, FetchingDealRoomEngageChatUsersResponse, FetchingDealRoomHistoryErrorResponse, FetchingDealRoomHistoryResponse, FetchingDealRoomSignalsErrorResponse, FetchingDealRoomSignalsResponse, FetchStakeholdersErrorResponse, FetchStakeholdersRequest, FetchStakeholdersResponse, MoveDealRoomSectionRequest, RearrangeAssetInDealRoomRequest, RecordsState, RemoveAssetFromDealRoomRequest, RenameDealRoomSectionRequest, StakeHolderTypeEnum, UpdateDealRoomCollaboratorsErrorResponse, UpdateDealRoomCollaboratorsRequest, UpdateDealRoomCollaboratorsResponse, UpdateDealRoomErrorResponse, UpdateDealRoomRequest, UpdateDealRoomResponse , DealRoomMarkAsTemplateResponse, DealRoomMarkAsTemplateErrorResponse, DealRoomMarkAsTemplateRequest} from "../../types/dealRoom";
import {
  DELETE_DEAL_ROOM, DELETING_DEAL_ROOM_FAILED, DELETING_DEAL_ROOM_SUCCEEDED, FETCH_DEAL_ROOMS,
  FETCH_DEAL_ROOMS_FAILED,
  FETCH_DEAL_ROOMS_SUCCEEDED,
  INVALIDATE_DEAL_ROOMS,
  INVALIDATE_DEAL_ROOMS_DELETION,
  INVALIDATE_DEAL_ROOMS_UPDATION,
  UPDATE_DEAL_ROOM,
  UPDATING_DEAL_ROOM_FALIED,
  UPDATING_DEAL_ROOM_SUCCEEDED,
  FETCHING_STAKEHOLDERS,
  FETCHING_STAKEHOLDERS_SUCCEEDED,
  FETCHING_STAKEHOLDERS_FAILED,
  DELETING_STAKEHOLDER,
  DELETING_STAKEHOLDER_FAILED,
  DELETING_STAKEHOLDER_SUCCEEDED,
  CREATE_DEAL_ROOM,
  CREATING_DEAL_ROOM_FAILED,
  CREATING_DEAL_ROOM_SUCCEEDED,
  INVALIDATE_DEAL_ROOM_CREATION_STATE,
  FETCH_DEAL_ROOM,
  FETCHING_DEAL_ROOM_FAILED,
  FETCHING_DEAL_ROOM_SUCCEEDED,
  EDIT_DEAL_ROOM_REQUEST,
  DEAL_ROOM_UPDATE_PROPERTY,
  DEAL_ROOM_ADD_ASSETS,
  DEAL_ROOM_REMOVE_ASSETS,
  CREATE_DEAL_ROOM_SECTION_REQUEST,
  REMOVE_DEAL_ROOM_SECTION_REQUEST,
  UPDATE_DEAL_ROOM_SECTION_REQUEST,
  MOVE_DEAL_ROOM_SECTION_REQUEST,
  DEAL_ROOM_REARRANGE_ASSETS,
  FETCHING_DEAL_ROOM_ASSETS_SUCCEEDED,
  FETCH_DEAL_ROOM_ASSETS,
  FETCHING_DEAL_ROOM_ASSETS_FAILED,
  FETCH_DEAL_ROOM_COLLABORATORS_REQUEST,
  FETCHING_DEAL_ROOM_COLLABORATORS_SUCCEDDED,
  FETCHING_DEAL_ROOM_COLLABORATORS_FAILED,
  UPDATE_DEAL_ROOM_COLLABORATORS_REQUEST,
  UPDATING_DEAL_ROOM_COLLABORATORS_SUCCEDDED,
  UPDATING_DEAL_ROOM_COLLABORATORS_FAILED,
  REARRANGE_DEAL_ROOM_ASSETS,
  FETCH_DEAL_ROOM_ASSETS_FOR_SECTION,
  FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_SUCCEEDED,
  FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_FAILED,
  INVALIDATE_DEAL_ROOM_EDIT_STATE,
  FETCH_DEAL_ROOM_SHARED_ASSETS,
  FETCHING_DEAL_ROOM_SHARED_ASSETS_SUCCEEDED,
  FETCHING_DEAL_ROOM_SHARED_ASSETS_FAILED,
  FETCH_DEAL_ROOM_SHARED_COLLECTIONS,
  FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_SUCCEEDED,
  FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_FAILED,
  FETCH_DEAL_ROOM_DETAILS,
  FETCHING_DEAL_ROOM_DETAILS_SUCCEEDED,
  FETCHING_DEAL_ROOM_DETAILS_FAILED,
  FETCH_DEAL_ROOM_SIGNALS,
  FETCHING_DEAL_ROOM_SIGNALS_SUCCEEDED,
  FETCHING_DEAL_ROOM_SIGNALS_FAILED,
  FETCH_DEAL_ROOM_HISTORY,
  FETCHING_DEAL_ROOM_HISTORY_SUCCEEDED,
  FETCHING_DEAL_ROOM_HISTORY_FAILED,
  INVALIDATE_DEAL_ROOM_COLLABORATORS,
  FETCH_DEAL_ROOM_CHAT_USERS_REQUEST,
  FETCHING_DEAL_ROOM_CHAT_USERS_SUCCEEDED,
  FETCHING_DEAL_ROOM_CHAT_USERS_FAILED,
  FETCH_DEAL_ROOM_ACTIVE_CHAT_USER_REQUEST,
  FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_SUCCEEDED,
  FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_FAILED,
  FETCH_DEAL_ROOM_SMARTCARDS,
  FETCHING_DEAL_ROOM_SMARTCARDS_SUCCEEDED,
  FETCHING_DEAL_ROOM_SMARTCARDS_FAILED,
  FETCHING_DEAL_ROOM_ASSET_ANALYTICS_SUCCEEDED,
  FETCH_DEAL_ROOM_EVENTS,
  FETCHING_DEAL_ROOM_EVENTS_SUCCEEDED,
  FETCHING_DEAL_ROOM_EVENTS_FAILED,
  CLONE_DEAL_ROOM,
  CLONING_DEAL_ROOM_SUCCEEDED,
  CLONING_DEAL_ROOM_FALIED,
  MARKING_DEAL_ROOM_AS_TEMPLATE_FAILED,
  MARKING_DEAL_ROOM_AS_TEMPLATE_SUCCEEDED,
  MARK_DEAL_ROOM_AS_TEMPLATE
} from "../actions/actionTypes";
import _ from "lodash";
import { nanoid } from "nanoid";
import { Asset } from "src/types/assets";
import { identifyUserForAdoption } from "src/legacy/redux/actions/adoption";

interface DealRoomsState {
  loading: boolean,
  items: DealRoom[],
  error: any,
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  },
  deletion: {
    [key: string]: DealRoomDeletionState;
  },
  update: {
    [key: string]: DealRoomUpdateState;
  },
  filtered: {
    [key: string]: DealRoomItemsState;
  },
  creation: DealRoomCreationState | null,
  dealRoom: {
    [key: string]: DealRoomState;
  },
  edit: {
    dealRoom: DealRoomEditState | null,
    assets: assetsInitialState,
    allAssets: {
      [key in AssetCatergory]: assetsInitialState
    }
  },
}

interface DealRoomEventsState {
  loading?: boolean,
  loaded?: boolean,
  items?: DealRoomEvents[],
  error?: any,
  pagination?: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
  }
}

interface DealRoomEngageChatUserState {
  item: DealRoomEngageChatUser | null;
  loading: boolean;
  loaded: boolean;
  error: any;
}

interface DealRoomState {
  loading: boolean,
  loaded: boolean,
  item: DealRoomEditState | null,
  error: any,
  assets: {
    [key in AssetCatergory]: assetsInitialState
  },
  stakeholders?: {
    people: {
      [type in StakeHolderTypeEnum]: {
        loading: boolean,
        items: any[],
        error: any,
        succeeded: boolean,
        pagination: {
          currentPage: number,
          totalPages: number,
          recordsPerPage: number,
          totalRecordsCount: number,
          hasMoreItems: boolean
        }
      }
    },
    deletion?: {
      deleting: boolean,
      deleted: boolean,
      error: any
    }
  },
  collaborators?: DealRoomCollaboratorsState,
  dealInsights: {
    sharedAssets: RecordsState<Asset>,
    sharedCollections: DealRoomSharedCollectionsState,
    details: DealRoomDetailsState,
    history: RecordsState<DealRoomHistory>,
    signals: RecordsState<DealRoomSignal>,
  },
  engage: {
    chatUsers: RecordsState<DealRoomEngageChatUser>,
    activeChatUser: DealRoomEngageChatUserState,
  },
  smartCards: {
    loading: boolean,
    loaded: boolean,
    items: any,
    error: any
  } | {},
  assetAnalytics: {
    [key: string]: string | number | null;
  },
  events: DealRoomEventsState,
  template: {
    loading: boolean,
    error: any
  },
}
interface DealRoomCollaboratorsState {
  loading?: boolean,
  loaded?: boolean,
  updating?: boolean,
  updated?: boolean,
  items: DealRoomCollaborate[],
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  },
  error?: any
}

export interface assetsInitialState {
  loading: boolean,
  succeeded: boolean,
  error: any
  items: DealRoomAsset[],
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  }
}

const initialDealRoomCreationState: DealRoomCreationState = {
  creating: false,
  created: false,
  item: null,
  error: null
}
interface DealRoomCreationState {
  creating: boolean,
  created: boolean,
  item: DealRoom | null,
  error: any
}

interface DealRoomDeletionState {
  id: string,
  deleting: boolean,
  deleted: boolean,
  error: any
}

const initialDealRoomDeletionState: DealRoomDeletionState = {
  id: '',
  deleting: false,
  deleted: false,
  error: null
}

const initialDealRoomUpdateState: DealRoomUpdateState = {
  id: '',
  updating: false,
  updated: false,
  item: null,
  error: null
}

interface DealRoomUpdateState {
  id: string,
  updating: boolean,
  updated: boolean,
  item: DealRoom | null,
  error: any
}

interface DealRoomItemsState {
  loading: boolean,
  items: DealRoom[],
  error: any,
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  },
}

const paginationInitialState = {
  currentPage: -1,
  totalPages: 0,
  recordsPerPage: 20,
  totalRecordsCount: 0,
  hasMoreItems: false
}

const initialDealRoomItemsState: DealRoomItemsState = {
  loading: false,
  items: [],
  error: null,
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 10,
    totalRecordsCount: 0,
    hasMoreItems: false,
  }
}

export const initialAssetsState: assetsInitialState = {
  loading: false,
  succeeded: false,
  error: null,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 20,
    totalRecordsCount: 0,
    hasMoreItems: false
  }
}

export const initialSharedAssetsState: RecordsState<Asset> = {
  items: [],
  pagination: {
    ...paginationInitialState,
  },
  loading: false,
  loaded: false,
  error: null
};

export const initialSharedCollectionsState: DealRoomSharedCollectionsState = { 
  loading: false,
  loaded: false,
  items: [],
  error: null
};

export const initialDealRoomDetailsState: DealRoomDetailsState = {
  loading: false,
  loaded: false,
  data: null,
  error: null
}

export const initialDealRoomHistoryState: RecordsState<DealRoomHistory> = {
  items: [],
  pagination: {
    ...paginationInitialState,
  },
  loading: false,
  loaded: false,
  error: null
};

export const initialDealRoomSignalsState: RecordsState<DealRoomSignal> = {
  items: [],
  pagination: {
    ...paginationInitialState,
  },
  loading: false,
  loaded: false,
  error: null
};

export const initialDealRoomCollaboratorsState: DealRoomCollaboratorsState = {
  loading: false,
  loaded: false,
  items: [],
  error: null,
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 10,
    totalRecordsCount: 0,
    hasMoreItems: false
  }
};

export const initialDealState = {
  sharedAssets: initialSharedAssetsState,
  sharedCollections: initialSharedCollectionsState,
  details: initialDealRoomDetailsState,
  history: initialDealRoomHistoryState,
  signals: initialDealRoomSignalsState,
}

const dealRoomAssetsState = {
  [AssetCatergory.INTERNAL]: initialAssetsState,
  [AssetCatergory.EXTERNAL]: initialAssetsState,
  [AssetCatergory.ALL]: initialAssetsState,
}

const initialStakeholdersState = {
  people: {
    [StakeHolderTypeEnum.INTERNAL]: {
      loading: false,
      items: [],
      error: null,
      succeeded: false,
      pagination: paginationInitialState
    },
    [StakeHolderTypeEnum.EXTERNAL]: {
      loading: false,
      items: [],
      error: null,
      succeeded: false,
      pagination: paginationInitialState
    }
  },
  deletion: {
    deleting: false,
    deleted: false,
    error: null
  }
}

const initialState: DealRoomsState = {
  loading: false,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 10,
    totalRecordsCount: 0,
    hasMoreItems: false
  },
  error: null,
  deletion: {},
  update: {},
  filtered: {},
  creation: null,
  dealRoom: {},
  edit: {
    dealRoom: null,
    assets: initialAssetsState,
    allAssets: {
      [AssetCatergory.INTERNAL]: initialAssetsState,
      [AssetCatergory.EXTERNAL]: initialAssetsState,
      [AssetCatergory.ALL]: initialAssetsState,
    }
  }
}

export function dealRoomsReducer(state: DealRoomsState = initialState, action: UnknownAction): DealRoomsState {
  switch (action.type) {

    case FETCH_DEAL_ROOMS: {

      const { filter } = action.payload as FetchDealRoomsRequest;

      if (filter) {
        const listState = state.filtered[filter] || initialDealRoomItemsState;
        return {
          ...state,
          filtered: {
            ...state.filtered,
            [filter]: {
              ...listState,
              loading: true
            }
          }
        }
      }


      return {
        ...state,
        loading: true
      }

    }

    case FETCH_DEAL_ROOMS_SUCCEEDED: {

      const { filter, response } = action.payload as FetchDealRoomsResponse;

      let existingItems: DealRoom[] = state.items;
      if (filter) {
        existingItems = _.get(state, `filtered['${filter}'].items`) || [];
      }

      let records = _.get(response, 'dealRooms',[])
      const pageNumber = _.get(response, "pagination.pageNumber", 0);
      const totalPagesCount = _.get(response, "pagination.totalPagesCount", 0);
      const itemsPerPage = _.get(response, "pagination.itemsPerPage", 0);
      const totalItemCount = _.get(response, "pagination.totalItemCount", 0);

      if (pageNumber > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, 'id');

      if (filter) {
        const listState = state.filtered[filter] || initialDealRoomItemsState;
        return {
          ...state,
          filtered: {
            ...state.filtered,
            [filter]: {
              ...listState,
              loading: false,
              items: records,
              pagination: {
                currentPage: pageNumber,
                totalPages: totalPagesCount,
                recordsPerPage: itemsPerPage,
                totalRecordsCount: totalItemCount,
                hasMoreItems: pageNumber < totalPagesCount - 1
              }
            }
          }
        }
      }

      return {
        ...state,
        loading: false,
        items: records,
        pagination: {
          currentPage: pageNumber,
          totalPages: totalPagesCount,
          recordsPerPage: itemsPerPage,
          totalRecordsCount: totalItemCount,
          hasMoreItems: pageNumber < totalPagesCount - 1
        },
      }
    } 

    case FETCH_DEAL_ROOMS_FAILED: {

      const error = action.payload;
      return {
        ...state,
        loading: false,
        error: error
      }
    }


    case DELETE_DEAL_ROOM: {
      const { id } = action.payload as DeleteDealRoomRequest;
      let deletionState = state.deletion[id] || initialDealRoomDeletionState;

      deletionState = {
        ...deletionState,
        id,
        deleting: true,
        deleted: false,
        error: null
      }

      return {
        ...state,
        deletion: {
          ...state.deletion,
          [id]: deletionState
        }
      }
    }

    case DELETING_DEAL_ROOM_SUCCEEDED: {
      const { id } = action.payload as DeleteDealRoomResponse;
      const deletionState = state.deletion[id];
      if (!deletionState) {
        return state;
      }

      const items = state.items.filter((item) => {
        return item.id !== id;
      });


      const filtered = Object.keys(state.filtered).reduce((acc: { [key: string]: DealRoomItemsState }, key) => {
        const listState = state.filtered[key];
        const items = listState.items.filter((item) => {
          return item.id !== id;
        });

        acc[key] = {
          ...listState,
          items
        }

        return acc;
      }, {});

      return {
        ...state,
        items,
        filtered,
        deletion: {
          ...state.deletion,
          [id]: {
            ...deletionState,
            deleting: false,
            deleted: true,
            error: null
          }
        }
      }
    }

    case DELETING_DEAL_ROOM_FAILED: {
      const { id, error } = action.payload as DeleteDealRoomErrorResponse;
      const deletionState = state.deletion[id];
      if (!deletionState) {
        return state;
      }

      return {
        ...state,
        deletion: {
          ...state.deletion,
          [id]: {
            ...deletionState,
            deleting: false,
            deleted: false,
            error: error
          }
        }
      }
    }

    case INVALIDATE_DEAL_ROOMS: {
      return {
        ...state,
        loading: false,
        items: [],
        pagination: {
          currentPage: -1,
          totalPages: 0,
          recordsPerPage: 10,
          totalRecordsCount: 0,
          hasMoreItems: false
        },
        error: null,
        filtered: {}
      }
    }

    case UPDATE_DEAL_ROOM: {
      const { id } = action.payload as UpdateDealRoomRequest;
      let updateState = state.update[id] || initialDealRoomUpdateState;

      updateState = {
        ...updateState,
        id,
        updating: true,
        updated: false,
        item: null,
        error: null
      }

      return {
        ...state,
        update: {
          ...state.update,
          [id]: updateState
        }
      }
    }

    case UPDATING_DEAL_ROOM_SUCCEEDED: {
      const { response } = action.payload as UpdateDealRoomResponse;
      const id = response.id;
      if (!id) {
        return state;
      }

      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      let editState = state.edit;
      if (editState?.dealRoom?.id !== id) {
        editState = {
          dealRoom: null,
          assets: initialAssetsState,
          allAssets: {
            [AssetCatergory.INTERNAL]: initialAssetsState,
            [AssetCatergory.EXTERNAL]: initialAssetsState,
            [AssetCatergory.ALL]: initialAssetsState
          }
        }
      }

      let dealRoomState = state.dealRoom[id];
      if (dealRoomState) {
        const sections = (response.sections || []).map((section, index): DealRoomSectionState => {
          const existingSection = _.get(editState, `dealRoom.sections[${index}]`);

          if (existingSection) {
            return {
              uid: existingSection.uid,
              item: {
                ...section,
                dealRoom: id,
                assets: {
                  ...existingSection?.item?.assets || initialAssetsState,
                  items: existingSection.item?.assets?.items || []
                }
              },
              loading: existingSection.loading,
              loaded: existingSection.loaded,
              error: null
            }
          }

          return {
            uid: nanoid(6),
            loading: true,
            loaded: false,
            item: {
              ...section,
              dealRoom: id
            },
            error: null
          }
        }) as DealRoomSectionState[];

        dealRoomState = {
          ...dealRoomState,
          item: {
            ...response,
            sections: sections || []
          },
        }
      }


      const items = state.items.map((item) => {
        if (item.id === id) {
          return response;
        }

        return item;
      });

      const filtered = Object.keys(state.filtered).reduce((acc: { [key: string]: DealRoomItemsState }, key) => {
        const listState = state.filtered[key];
        const items = listState.items.map((item) => {
          if (item.id === id) {
            return response;
          }

          return item;
        });

        acc[key] = {
          ...listState,
          items
        }

        return acc;
      }, {});


      return {
        ...state,
        items,
        filtered,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            updating: false,
            updated: true,
            item: response,
            error: null
          }
        },
        dealRoom: {
          ...state.dealRoom,
          [id]: dealRoomState
        },
      }
    }

    case UPDATING_DEAL_ROOM_FALIED: {
      const { id, error } = action.payload as UpdateDealRoomErrorResponse;
      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            updating: false,
            updated: false,
            error: error
          }
        }
      }
    }


    case INVALIDATE_DEAL_ROOMS_UPDATION: {
      return {
        ...state,
        update: {}
      }
    }

    case INVALIDATE_DEAL_ROOMS_DELETION: {
      return {
        ...state,
        deletion: {}
      }
    }

    case FETCHING_STAKEHOLDERS: {
      const { dealRoomId, type } = action.payload as FetchStakeholdersRequest;
      const dealRoom = _.get(state, `dealRoom[${dealRoomId}]`);
      const stakeholders = _.get(state, `dealRoom[${dealRoomId}].stakeholders`, initialStakeholdersState)
      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoom,
            stakeholders: {
              ...stakeholders,
              people: {
                ...stakeholders.people,
                [type]: {
                  ...stakeholders.people[type],
                  loading: true,
                  error: null,
                  succeeded: false,
                }
              }
            }
          }
        }

      }
    }

    case FETCHING_STAKEHOLDERS_SUCCEEDED: {
      const {records, pagination,  dealRoomId, type } = action.payload as FetchStakeholdersResponse;

      const dealRoom = _.get(state, `dealRoom[${dealRoomId}]`);
      const stakeholders = _.get(state, `dealRoom[${dealRoomId}].stakeholders`, initialStakeholdersState)

      const existingItems = _.get(stakeholders,`people[${type}].items`) || [];

      var items = records || [];
      if (pagination.pageNumber > 0) {
        items = [...existingItems, ...records];
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoom,
            stakeholders: {
              ...stakeholders,
              people: {
                ...stakeholders.people,
                [type]: {
                  ...stakeholders.people[type],
                  loading: false,
                  items: items,
                  error: null,
                  succeeded: true,
                  pagination: {
                    currentPage: pagination.pageNumber,
                    totalPages: pagination.totalPagesCount,
                    recordsPerPage: pagination.itemsPerPage,
                    totalRecordsCount: pagination.totalItemCount,
                    hasMoreItems: pagination.pageNumber < pagination.totalPagesCount - 1
                  }
                }
              }
            }
          }
        }
      }
    }

    case FETCHING_STAKEHOLDERS_FAILED: {
      const { dealRoomId, type, error } = action.payload as FetchStakeholdersErrorResponse;

      const dealRoom = _.get(state, `dealRoom[${dealRoomId}]`);
      const stakeholders = _.get(state, `dealRoom[${dealRoomId}].stakeholders`, initialStakeholdersState)

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoom,
            stakeholders: {
              ...stakeholders,
              people: {
                ...stakeholders.people,
                [type]: {
                  ...stakeholders.people[type],
                  loading: false,
                  error: error,
                  succeeded: false
                }
              }
            }
          }
        }
      }
    }

    case DELETING_STAKEHOLDER: {
      const { dealRoomId } = action.payload as DeleteStakeholderRequest;
      const dealRoom = _.get(state, `dealRoom[${dealRoomId}]`);
      const stakeholders = _.get(state, `dealRoom[${dealRoomId}].stakeholders`, initialStakeholdersState)

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoom,
            stakeholders: {
              ...stakeholders,
              deletion: {
                deleting: true,
                deleted: false,
                error: null
              }
            }
          }
        }

      }
    }

    case DELETING_STAKEHOLDER_SUCCEEDED: {
      const { dealRoomId } = action.payload as DeleteStakeholderResponse;
      const dealRoom = _.get(state, `dealRoom[${dealRoomId}]`);
      const stakeholders = _.get(state, `dealRoom[${dealRoomId}].stakeholders`, initialStakeholdersState)

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoom,
            stakeholders: {
              ...stakeholders,
              deletion: {
                deleting: false,
                deleted: true,
                error: null
              }
            }
          }
        }

      }
    }

    case DELETING_STAKEHOLDER_FAILED: {
      const { dealRoomId, error } = action.payload as DeleteStakeholderErrorResponse;
      const dealRoom = _.get(state, `dealRoom[${dealRoomId}]`);
      const stakeholders = _.get(state, `dealRoom[${dealRoomId}].stakeholders`, initialStakeholdersState)

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoom,
            stakeholders: {
              ...stakeholders,
              deletion: {
                deleting: false,
                deleted: false,
                error: error
              }
            }
          }
        }
      }
    }


    case CREATE_DEAL_ROOM: {
      return {
        ...state,
        creation: {
          ...initialDealRoomCreationState,
          creating: true
        }
      }
    }

    case CREATING_DEAL_ROOM_SUCCEEDED: {
      const { response } = action.payload as CreateDealRoomResponse;
      const creationState = state.creation;
      if (!creationState) {
        return state;
      }

      return {
        ...state,
        creation: {
          ...creationState,
          creating: false,
          created: true,
          item: response,
          error: null
        }
      }
    }

    case CREATING_DEAL_ROOM_FAILED: {
      const { error } = action.payload as CreateDealRoomErrorResponse;
      const creationState = state.creation;
      if (!creationState) {
        return state;
      }

      return {
        ...state,
        creation: {
          ...creationState,
          creating: false,
          created: true,
          error: error
        }
      }
    }

    case INVALIDATE_DEAL_ROOM_CREATION_STATE: {
      return {
        ...state,
        creation: null
      }
    }

    //Fetch DealRoom 
    case FETCH_DEAL_ROOM: {
      const request = action.payload as FetchDealRoomRequest;
      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [request.id]: {
            ...state.dealRoom[request.id],
            loading: true,
            loaded: false,
            item: null,
            error: null,
            assets: dealRoomAssetsState,
            dealInsights: { ...initialDealState },
            template: {
              loading: false,
              error: null,
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_SUCCEEDED: {
      const { response } = action.payload as FetchDealRoomResponse;

      if (!response || !response.id) {
        return state;
      }

      const dealRoomState = state.dealRoom[response.id];
      if (!dealRoomState) {
        return state;
      }
      // loading: boolean,
      // succeeded: boolean,
      // error: any
      // items: DealRoomAsset[],
      // pagination: {
      //   currentPage: number,
      //   totalPages: number,
      //   recordsPerPage: number,
      //   totalRecordsCount: number,
      //   hasMoreItems: boolean
      // }
      const sections = (response.sections || []).map((section): DealRoomSectionState => {
        return {
          uid: nanoid(6),
          loading: true,
          loaded: false,
          item: {
            ...section,
            assets: _.get(section, 'assets', initialAssetsState),
            dealRoom: response.id,
          },
          error: null,
        }
      }) as DealRoomSectionState[];

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [response.id]: {
            ...state.dealRoom[response.id],
            loading: false,
            loaded: true,
            item: {
              ...response,
              sections: sections || []
            },
            error: null,
            assets: _.get(state, `dealRoom[${response.id}].assets`, dealRoomAssetsState),
            dealInsights: {
              ..._.get(state, `dealRoom[${response.id}].dealInsights`),
            },
            template: {
              loading: false,
              error: null
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_FAILED: {
      const { id, error } = action.payload as FetchDealRoomErrorResponse;

      const dealRoomState = state.dealRoom[id];
      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [id]: {
            ...state.dealRoom[id],
            loading: false,
            loaded: false,
            item: null,
            error: error,
            assets: _.get(state, `dealRoom[${id}].assets`, dealRoomAssetsState),
            dealInsights: {
              ...state.dealRoom[id].dealInsights,
            }
          }
        }
      }
    }

    case EDIT_DEAL_ROOM_REQUEST: {
      const { dealRoom, assets, allAssets } = action.payload as DealRoomEditRequest;

      return {
        ...state,
        edit: {
          dealRoom: dealRoom,
          assets: assets,
          allAssets: allAssets
        }
      }
    }

    case DEAL_ROOM_UPDATE_PROPERTY: {
      const { property, value } = action.payload as { property: string, value: any };
      const dealRoomState = state.edit;
      if (!dealRoomState) {
        return state;
      }

      const dealRoom = {
        ...dealRoomState.dealRoom,
        [property]: value
      }

      return {
        ...state,
        edit: {
          ...dealRoomState,
          dealRoom: dealRoom
        }
      };
    }

    case DEAL_ROOM_ADD_ASSETS: {
      const { section, assets, addAt } = action.payload as AddAssetToDealRoomRequest;
      const dealRoomState = state.edit;
      if (!dealRoomState) {
        return state;
      }

      let sections = _.get(dealRoomState, "dealRoom.sections", []);
      let existingAssets: DealRoomAsset[] = _.get(dealRoomState, `allAssets.[${AssetCatergory.INTERNAL}].items`, []);

      if (section !== undefined) {
        sections = sections.map((item, index) => {
          if (index === section) {
            let existing = item.item?.assets?.items || [];
            if (addAt === 'start') {
              existing = [...assets, ...existing];
            } else {
              existing = [...existing, ...assets];
            }

            existing = _.uniqBy(existing, 'id');

            return {
              ...item,
              item: {
                ...item.item,
                name: _.get(item, 'item.name') || '',
                // assets: existing,
                assets: {
                  ...item.item?.assets,
                  items: existing
                }
              }
            }
          }

          return item;
        });
      } else {
        if (addAt === 'start') {
          existingAssets = [...assets, ...existingAssets];
        } else {
          existingAssets = [...existingAssets, ...assets];
        }

        existingAssets = _.uniqBy(existingAssets, 'id');
      }

      return {
        ...state,
        edit: {
          dealRoom: {
            ...dealRoomState.dealRoom,
            sections: sections
          },
          assets: {
            ...dealRoomState.assets,
            items: existingAssets
          },
          allAssets: {
            ...dealRoomState.allAssets,
            [AssetCatergory.INTERNAL]: {
              ...dealRoomState.allAssets[AssetCatergory.INTERNAL],
              items: existingAssets
            }
          }
        }
      };
    }

    case DEAL_ROOM_REMOVE_ASSETS: {
      const { section, asset } = action.payload as RemoveAssetFromDealRoomRequest;
      const dealRoomState = state.edit;
      if (!dealRoomState) {
        return state;
      }

      let sections = _.get(dealRoomState, "dealRoom.sections", []);
      if (section !== undefined) {
        sections = sections.map((item, index) => {
          if (index === section) {
            return {
              ...item,
              item: {
                ...item.item,
                name: item.item?.name || '',
                assets: {
                  ...item.item?.assets,
                  items: item.item?.assets?.items?.filter((a) => a.id !== asset) || []
                }
              }
            }
          }

          return item;
        });
      }

      const assets = _.get(dealRoomState, `allAssets.[${AssetCatergory.INTERNAL}].items`, []).filter((a : DealRoomAsset) => a.id !== asset);

      return {
        ...state,
        edit: {
          dealRoom: {
            ...dealRoomState.dealRoom,
            sections: sections
          },
          assets: {
            ...dealRoomState.assets,
            items: assets
          },
          allAssets: {
            ...dealRoomState.allAssets,
            [AssetCatergory.INTERNAL]: {
              ...dealRoomState.allAssets[AssetCatergory.INTERNAL],
              items: assets
            }
          }
        }
      };


    }

    case CREATE_DEAL_ROOM_SECTION_REQUEST: {
      const { name } = action.payload as CreateDealRoomSectionRequest;

      const dealRoomState = state.edit;
      if (!dealRoomState) {
        return state;
      }

      const sectionState = {
        uid: nanoid(6),
        loading: false,
        loaded: true,
        item: {
          name,
          dealRoom: dealRoomState.dealRoom?.id,
          assets: initialAssetsState,
        },
        error: null
      }

      let sections = dealRoomState.dealRoom?.sections || [];
      sections = [...sections, sectionState];

      return {
        ...state,
        edit: {
          ...dealRoomState,
          dealRoom: {
            ...dealRoomState.dealRoom,
            sections
          }
        }
      };
    }

    case REMOVE_DEAL_ROOM_SECTION_REQUEST: {
      const { index } = action.payload as RenameDealRoomSectionRequest;

      const dealRoomState = state.edit;
      if (!dealRoomState) {
        return state;
      }

      let sections = dealRoomState.dealRoom?.sections || [];
      sections = sections.filter((item, i) => i !== index);

      return {
        ...state,
        edit: {
          ...dealRoomState,
          dealRoom: {
            ...dealRoomState.dealRoom,
            sections
          }
        }
      };
    }

    case UPDATE_DEAL_ROOM_SECTION_REQUEST: {
      const { index, name } = action.payload as RenameDealRoomSectionRequest;

      const dealRoomState = state.edit;
      if (!dealRoomState) {
        return state;
      }

      let sections = dealRoomState.dealRoom?.sections || [];

      if (!sections) return state;

      sections = sections.map((item, i) => {
        if (i === index) {
          if (item.item) {
            return {
              ...item,
              item: {
                ...item.item,
                name,
                assets: item.item?.assets || []
              }
            }
          }
          return item;
        }
        return item;
      });

      return {
        ...state,
        edit: {
          ...dealRoomState,
          dealRoom: {
            ...dealRoomState.dealRoom,
            sections
          }
        }
      };
    }

    case MOVE_DEAL_ROOM_SECTION_REQUEST: {
      const { from, to } = action.payload as MoveDealRoomSectionRequest;

      const dealRoomState = state.edit;
      if (!dealRoomState) {
        return state;
      }

      let sections = dealRoomState.dealRoom?.sections || [];
      sections = [...sections];
      sections.splice(to, 0, sections.splice(from, 1)[0]);

      return {
        ...state,
        edit: {
          ...dealRoomState,
          dealRoom: {
            ...dealRoomState.dealRoom,
            sections
          }
        }
      };
    }

    case FETCH_DEAL_ROOM_ASSETS: {
      const { id, assetCategory, page } = action.payload as FetchDealRoomAssetsRequest;
      const dealRoomState = state.dealRoom[id];

      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [id]: {
            ...dealRoomState,
            assets: {
              ...dealRoomState.assets,
              [assetCategory]: {
                ...dealRoomState.assets[assetCategory],
                loading: true,
                succeeded: false,
                error: null,
                items: page === 0 ? [] : _.get(dealRoomState,`assets[${assetCategory}].items`),
              }
            }
          }
        }
      }

    }
    
    case FETCHING_DEAL_ROOM_ASSETS_SUCCEEDED: {
      const { id, pagination, records, assetCategory } = action.payload as FetchDealRoomAssetsResponse;
      let items = records;
      const dealRoomState = state.dealRoom[id];
      const existingItems = _.get(dealRoomState, `assets[${assetCategory}].items`, []);
      if (pagination.pageNumber > 0) {
        items = [...existingItems, ...items];
      }

      items = _.uniqBy(items, 'id');
    
      let editState = state.edit;
    
      if (editState) {
        // const existingEditItems = editState.assets?.items || [];
        const existingEditItems = _.get(editState, `allAssets.[${assetCategory}].items`, []);
        let updatedEditAssetItems = records;
    
        if (pagination.pageNumber > 0) {
          updatedEditAssetItems = [...existingEditItems, ...updatedEditAssetItems];
        }
        updatedEditAssetItems = _.uniqBy(updatedEditAssetItems, 'id');
    
        editState = {
          ...editState,
          assets: {
            ...editState.assets,
            loading: false,
            succeeded: true,
            items: updatedEditAssetItems,
            pagination: {
              currentPage: pagination.pageNumber,
              totalPages: pagination.totalPagesCount,
              recordsPerPage: pagination.itemsPerPage,
              totalRecordsCount: pagination.totalItemCount,
              hasMoreItems: pagination.pageNumber < pagination.totalPagesCount - 1,
            },
          },
          allAssets: {
            ...editState.allAssets,
            [assetCategory]: {
              loading: false,
              succeeded: true,
              items: updatedEditAssetItems,
              pagination: {
                currentPage: pagination.pageNumber,
                totalPages: pagination.totalPagesCount,
                recordsPerPage: pagination.itemsPerPage,
                totalRecordsCount: pagination.totalItemCount,
                hasMoreItems: pagination.pageNumber < pagination.totalPagesCount - 1,
              },
            }
          }
        };
      }
    
      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [id]: {
            ...dealRoomState,
            assets: {
              ...dealRoomState.assets,
              [assetCategory]: {
                loading: false,
                succeeded: true,
                items: items,
                pagination: {
                  currentPage: pagination.pageNumber,
                  totalPages: pagination.totalPagesCount,
                  recordsPerPage: pagination.itemsPerPage,
                  totalRecordsCount: pagination.totalItemCount,
                  hasMoreItems: pagination.pageNumber < pagination.totalPagesCount - 1,
                }
              }
            }
          }
        },
        edit: editState,
      };
    }

    case FETCHING_DEAL_ROOM_ASSETS_FAILED: {
      const { id, error, assetCategory } = action.payload as FetchDealRoomAssetsErrorResponse;
      const dealRoomState = state.dealRoom[id];
      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [id]: {
            ...dealRoomState,
            assets: {
              ...dealRoomState.assets,
              [assetCategory]: {
                ...dealRoomState.assets[assetCategory],
                loading: false,
                succeeded: false,
                error: error
              }

            }
          }
        }
      }
    }


    case FETCH_DEAL_ROOM_COLLABORATORS_REQUEST: {
      const { dealRoom } = action.payload as FetchDealRoomCollaboratorsRequest;

      const dealRoomState = state.dealRoom[dealRoom];
      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoom]: {
            ...dealRoomState,
            collaborators: {
              ..._.get(dealRoomState, 'collaborators', initialDealRoomCollaboratorsState),
              items: _.get(dealRoomState, 'collaborators.items', []),
              loading: true,
              loaded: false,
              error: null,
              pagination: _.get(dealRoomState, 'collaborators.pagination', {
                currentPage: -1,
                totalPages: 0,
                recordsPerPage: 10,
                totalRecordsCount: 0,
                hasMoreItems: false
              }),
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_COLLABORATORS_SUCCEDDED: {
      const { dealRoom, response } = action.payload as FetchDealRoomCollaboratorsResponse;

      const dealRoomState = state.dealRoom[dealRoom];
      if (!dealRoomState) {
        return state;
      }

      const existingItems = dealRoomState.collaborators?.items || [];
      let records = response.users;

      const pageNumber = _.get(response, "pagination.pageNumber", 0);
      const totalPagesCount = _.get(response, "pagination.totalPagesCount", 0);
      const itemsPerPage = _.get(response, "pagination.itemsPerPage", 0);
      const totalItemCount = _.get(response, "pagination.totalItemCount", 0);

      if (pageNumber > 0) {
        records = [...existingItems, ...records];
      }

      records = _.orderBy(
        records,
        [
          "entityType",
          (item) => {
            const entityType = _.get(item, "entityType");
            if (entityType === "user") {
              return item.enabled === true ? 0 : 1;
            }
            return 0;
          },
          (item) => {
            const entityType = _.get(item, "entityType");
            let name = "";
            if (entityType === "user") {
              name = item.name || "";
            } 
            return _.toLower(name);
          },
        ],
        ["desc", "asc", "asc"],
      );

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoom]: {
            ...dealRoomState,
            collaborators: {
              loading: false,
              loaded: true,
              error: null,
              items: records,
              pagination: {
                currentPage: pageNumber,
                totalPages: totalPagesCount,
                recordsPerPage: itemsPerPage,
                totalRecordsCount: totalItemCount,
                hasMoreItems: pageNumber < totalPagesCount - 1
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_COLLABORATORS_FAILED: {
      const { dealRoom, error } = action.payload as FetchDealRoomCollaboratorsErrorResponse;

      const dealRoomState = state.dealRoom[dealRoom];
      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoom]: {
            ...dealRoomState,
            collaborators: {
              ...dealRoomState.collaborators,
              loading: false,
              loaded: false,
              error: error,
            } as DealRoomCollaboratorsState
          }
        }
      }
    }

    case UPDATE_DEAL_ROOM_COLLABORATORS_REQUEST: {
      const { dealRoom } = action.payload as UpdateDealRoomCollaboratorsRequest;

      const dealRoomState = state.dealRoom[dealRoom];
      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoom]: {
            ...dealRoomState,
            collaborators: {
              ...dealRoomState.collaborators,
              updating: true,
              updated: false,
            } as DealRoomCollaboratorsState
          }
        }
      }
    }

    case UPDATING_DEAL_ROOM_COLLABORATORS_SUCCEDDED: {
      const { dealRoom } = action.payload as UpdateDealRoomCollaboratorsResponse;

      const dealRoomState = state.dealRoom[dealRoom];
      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoom]: {
            ...dealRoomState,
            collaborators: {
              ...dealRoomState.collaborators,
              updating: false,
              updated: true,
            } as DealRoomCollaboratorsState
          }
        }
      }
    }

    case UPDATING_DEAL_ROOM_COLLABORATORS_FAILED: {
      const { dealRoom, error } = action.payload as UpdateDealRoomCollaboratorsErrorResponse;

      const dealRoomState = state.dealRoom[dealRoom];
      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoom]: {
            ...dealRoomState,
            collaborators: {
              ...dealRoomState.collaborators,
              updating: false,
              updated: false,
              error: error
            } as DealRoomCollaboratorsState
          }
        }
      }
    }

    case REARRANGE_DEAL_ROOM_ASSETS: {
      // const id = _.get(action, "payload.id", "") as string;
      // const assets = _.get(action, "payload.assets", []) as any;

      const { id, updatedAssets: assets, sectionIndex } = action.payload as RearrangeAssetInDealRoomRequest;

      let editState = state.edit;
      const dealRoomState = state.dealRoom[id];

      if (!dealRoomState || !id) {
        return state;
      }


      if (sectionIndex !== undefined) {
        const sections = state.edit?.dealRoom?.sections;

        if (!sections) return state;

        return {
          ...state,
          edit: {
            ...state.edit,
            dealRoom: {
              ...state.edit.dealRoom,
              sections: sections.map((section, index) => {
                if (index === sectionIndex && section.item) {
                  return {
                    ...section,
                    item: {
                      ...section.item,
                      assets: {
                        ...section.item?.assets,
                        items: assets
                      }
                    }
                  }
                }
                return section;
              })
            }
          }
        }
      }

      return {
        ...state,
        edit: {
          ...state.edit,
          allAssets:{
            ...state.edit?.allAssets,
            [AssetCatergory.INTERNAL]: {
              ...state.edit?.allAssets[AssetCatergory.INTERNAL],
              items: assets
            }
          }
        }
      }
    }

    case FETCH_DEAL_ROOM_ASSETS_FOR_SECTION: {

      const { id, sectionId } = action.payload as FetchDealRoomAssetsForSectionRequest;

      const dealRoomState = state.dealRoom[id];
      if (!dealRoomState || !dealRoomState.item) {
        return state;
      }

      const sections = (dealRoomState.item.sections || []).map((item) => {
        if (item.item?.id === sectionId) {
          return {
            ...item,
            loading: true,
            item: {
              ...item.item,
              assets: {
                ...item.item?.assets,
                loading: true,
              }
            }
          }
        }

        return item;
      }) as DealRoomSectionState[];

      let editState = state.edit;
      if (editState && editState.dealRoom != null) {
        const editSections = (editState.dealRoom?.sections || []).map((item) => {
          if (item.item?.id === sectionId) {
            return {
              ...item,
              item: {
                ...item.item,
                dealRoom: id,
                assets: {
                  ...item.item?.assets,
                  loading: true,
                  succeeded: false,
                  error: null,

                },
              }
            }
          }

          return item;
        });

        editState = {
          ...editState,
          dealRoom: {
            ...editState.dealRoom,
            sections: editSections
          }
        }
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [id]: {
            ...dealRoomState,
            item: {
              ...dealRoomState.item,
              sections: sections
            }
          }
        },
        edit: editState
      };
    }

    case FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_SUCCEEDED: {
      const { id, sectionId, pagination, records } = action.payload as FetchDealRoomAssetsForSectionResponse;

      const dealRoomState = state.dealRoom[id];
      if (!dealRoomState || !dealRoomState.item) {
        return state;
      }

      // const existingItems = _.get(dealRoomState, `item.sections[${sectionId}].item.assets.items`, []);
      // let records = response.records;
      // if (response.currentPage > 0) {
      //   records = [...existingItems, ...records];
      // }

      // records = _.uniqBy(records, 'id');

      const sections = (dealRoomState.item.sections || []).map((item) => {
        if (item.item?.id === sectionId) {
          const existingItems = item.item?.assets?.items || [];
          let items = records;
          if (pagination.pageNumber > 0) {
            items = [...existingItems, ...items];
          }

          return {
            ...item,
            loading: false,
            loaded: true,
            item: {
              ...item.item,
              assets: {
                loading: false,
                succeeded: true,
                error: null,
                items: items,
                pagination: {
                  currentPage: pagination.pageNumber,
                  totalPages: pagination.totalPagesCount,
                  recordsPerPage: pagination.itemsPerPage,
                  totalRecordsCount: pagination.totalItemCount,
                  hasMoreItems: pagination.pageNumber < pagination.totalPagesCount - 1
                }
              }
            }
          }
        }

        return item;
      }) as DealRoomSectionState[];


      let editState = state.edit;
      if (editState && editState.dealRoom != null) {
        const editSections = (editState.dealRoom?.sections || []).map((item) => {
          if (item.item?.id === sectionId) {
            return {
              ...item,
              item: {
                ...item.item,
                dealRoom: id,
                assets: {
                  ...item.item?.assets,
                  items: records,
                  loading: false,
                  succeeded: true,
                  error: null,
                },
              },
              loading: false,
              loaded: true,
            }
          }

          return item;
        });

        editState = {
          ...editState,
          dealRoom: {
            ...editState.dealRoom,
            sections: editSections
          }
        }
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [id]: {
            ...dealRoomState,
            item: {
              ...dealRoomState.item,
              sections: sections
            }
          }
        },
        edit: editState
      };
    }

    case FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_FAILED: {
      const { id, sectionId, error } = action.payload as FetchDealRoomAssetsForSectionErrorResponse;

      const dealRoomState = state.dealRoom[id];
      if (!dealRoomState || !dealRoomState.item) {
        return state;
      }

      const sections = (dealRoomState.item.sections || []).map((item) => {
        if (item.item?.id === sectionId) {
          return {
            ...item,
            loading: false,
            loaded: false,
            item: {
              ...item.item,
              assets: {
                ...item.item?.assets,
                loading: false,
                succeeded: false,
                error: error,
              }
            }
          }
        }

        return item;
      }) as DealRoomSectionState[];

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [id]: {
            ...dealRoomState,
            item: {
              ...dealRoomState.item,
              sections: sections
            }
          }
        }
      }
    }

    case FETCH_DEAL_ROOM_CHAT_USERS_REQUEST: {
      const {dealRoomId} = action.payload as FetchDealRoomEngageChatUsersRequest;

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ..._.get(state, `dealRoom[${dealRoomId}]`),
            engage: {
              ..._.get(state, `dealRoom[${dealRoomId}].engage`),
              chatUsers: {
                ..._.get(state, `dealRoom[${dealRoomId}].engage.chatUsers`),
                loading: true,
              }
            }
          }
        }
      };
    }

    case FETCHING_DEAL_ROOM_CHAT_USERS_SUCCEEDED: {
      const { response, dealRoomId } = action.payload as FetchingDealRoomEngageChatUsersResponse;

      const existingItems = _.get(state, `dealRoom[${dealRoomId}].engage.chatUsers.items`, []);
      const newItems = _.get(response, 'records', []);
      const currentPage = _.get(response, 'currentPage');
      const totalPages = _.get(response, 'totalPages');
      const recordsPerPage = _.get(response, 'recordsPerPage');
      const totalRecordsCount = _.get(response, 'totalRecordsCount');

      let records = newItems;
      if (currentPage > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, 'id');

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom[${dealRoomId}]`),
            engage: {
              ..._.get(state, `dealRoom[${dealRoomId}].engage`),
              chatUsers: {
                ..._.get(state, `dealRoom[${dealRoomId}].engage.chatUsers`),
                items: records,
                loading: false,
                loaded: true,
                pagination: {
                  currentPage,
                  totalPages,
                  recordsPerPage,
                  totalRecordsCount,
                  hasMoreItems: currentPage < totalPages - 1
                }
              }
            }
          }
        }
      };
    }

    case FETCHING_DEAL_ROOM_CHAT_USERS_FAILED: {
      const { error, dealRoomId } = action.payload as FetchingDealRoomEngageChatUsersErrorResponse;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom[${dealRoomId}]`),
            engage: {
              ..._.get(state, `dealRoom[${dealRoomId}].engage`),
              chatUsers: {
                ..._.get(state, `dealRoom[${dealRoomId}].engage.chatUsers`),
                loading: false,
                error,
              }
            }
          }
        }
      };
    }

    case FETCH_DEAL_ROOM_ACTIVE_CHAT_USER_REQUEST: {
      const {dealRoomId} = action.payload as FetchDealRoomActiveChatUserRequest;

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ..._.get(state, `dealRoom[${dealRoomId}]`),
            engage: {
              ..._.get(state, `dealRoom[${dealRoomId}].engage`),
              activeChatUser: {
                ..._.get(state, `dealRoom[${dealRoomId}].engage.activeChatUser`),
                loading: true,
              }
            }
          }
        }
      };
    };

    case FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_SUCCEEDED: {
      const { response, dealRoomId } = action.payload as FetchingDealRoomActiveChatUserResponse;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom[${dealRoomId}]`),
            engage: {
              ..._.get(state, `dealRoom[${dealRoomId}].engage`),
              activeChatUser: {
                ..._.get(state, `dealRoom[${dealRoomId}].engage.activeChatUser`),
                item: response,
                loading: false,
                loaded: true,
              }
            }
          }
        }
      };
    }

    case FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_FAILED: {
      const { error, dealRoomId } = action.payload as FetchingDealRoomActiveChatUserErrorResponse;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom[${dealRoomId}]`),
            engage: {
              ..._.get(state, `dealRoom[${dealRoomId}].engage`),
              activeChatUser: {
                ..._.get(state, `dealRoom[${dealRoomId}].engage.activeChatUser`),
                loading: false,
                error,
              }
            }
          }
        }
      };
    }

    case INVALIDATE_DEAL_ROOM_EDIT_STATE: {
      return {
        ...state,
        edit: {
          dealRoom: null,
          assets: initialAssetsState,
          allAssets: {
            [AssetCatergory.INTERNAL]: initialAssetsState,
            [AssetCatergory.EXTERNAL]: initialAssetsState,
            [AssetCatergory.ALL]: initialAssetsState
          }
        }
      }
    }

    case FETCH_DEAL_ROOM_SHARED_ASSETS: {
      const { dealRoomId } = action.payload as FetchDealRoomSharedAssetsRequest;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              sharedAssets: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.sharedAssets`),
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_SHARED_ASSETS_SUCCEEDED: {
      const { response, dealRoomId } = action.payload as FetchDealRoomSharedAssetsResponse;
      const { records, currentPage, totalPages, recordsPerPage, totalRecordsCount } = response; 

      const existingItems = _.get(state, `dealRoom.[${dealRoomId}].dealInsights.sharedAssets.items`) || [];
      let items = records || [];
      if (currentPage > 0) {
        items = [...existingItems, ...records];
      }

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              sharedAssets: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.sharedAssets`),
                items,
                loading: false,
                loaded: true,
                pagination: {
                  ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.sharedAssets.pagination`),
                  currentPage,
                  totalPages,
                  recordsPerPage,
                  totalRecordsCount,
                  hasMoreItems: currentPage < totalPages - 1
                }
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_SHARED_ASSETS_FAILED: {
      const { error, dealRoomId } = action.payload as FetchDealRoomSharedAssetsErrorResponse;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              sharedAssets: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.sharedAssets`),
                error,
                loading: false,
                loaded: true,
              }
            }
          }
        }
      }
    }

    case FETCH_DEAL_ROOM_SHARED_COLLECTIONS: {
      const { dealRoomId } = action.payload as FetchDealRoomSharedCollectionsRequest;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              sharedCollections: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.sharedCollections`),
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_SUCCEEDED: {
      const { response, dealRoomId } = action.payload as FetchDealRoomSharedCollectionsResponse;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              sharedCollections: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.sharedCollections`),
                items: [...response],
                loading: false,
                loaded: true
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_FAILED: {
      const { error, dealRoomId } = action.payload as FetchDealRoomSharedCollectionsErrorResponse;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              sharedCollections: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.sharedCollections`),
                loading: false,
                loaded: true,
                error
              }
            }
          }
        }
      }
    }

    case FETCH_DEAL_ROOM_DETAILS: {
      const { dealRoomId } = action.payload as FetchDealRoomDetailsRequest;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              details: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.details`),
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_DETAILS_SUCCEEDED: {
      const { response, dealRoomId } = action.payload as FetchingDealRoomDetailsResponse;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              details: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.details`),
                data: response,
                loading: false,
                loaded: true
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_DETAILS_FAILED: {
      const { error, dealRoomId } = action.payload as FetchingDealRoomDetailsErrorResponse;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              details: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.details`),
                loading: false,
                loaded: true,
                error
              }
            }
          }
        }
      }
    }

    case FETCH_DEAL_ROOM_SIGNALS: {
      const { dealRoomId } = action.payload as FetchDealRoomSignalsRequest;
      
      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              signals: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.signals`),
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_SIGNALS_SUCCEEDED: {
      const { response, dealRoomId } = action.payload as FetchingDealRoomSignalsResponse;
      const { records, currentPage, totalPages, recordsPerPage } = response; 

      const existingItems = _.get(state, `dealRoom.[${dealRoomId}].dealInsights.signals.items`) || [];
      let items = records || [];
      if (currentPage > 0) {
        items = [...existingItems, ...records];
      }

      return {
        ...state,
        dealRoom: {
          ..._.get(state, `dealRoom`),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              signals: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.signals`),
                items,
                loading: false,
                loaded: true,
                pagination: {
                  ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.signals.pagination`),
                  currentPage,
                  totalPages,
                  recordsPerPage,
                  hasMoreItems: currentPage < totalPages - 1
                }
              }
            }
          }
        }
      } 
    }

    case FETCHING_DEAL_ROOM_SIGNALS_FAILED: {
      const { error, dealRoomId } = action.payload as FetchingDealRoomSignalsErrorResponse;
      return {
        ...state,
        dealRoom: {
          ..._.get(state, 'dealRoom'),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              signals: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.signals`),
                loading: false,
                loaded: true,
                error
              }
            }
          }
        }
      }
    }

    case FETCH_DEAL_ROOM_HISTORY: {
      const { dealRoomId } = action.payload as FetchDealRoomHistoryRequest;

      return {
        ...state,
        dealRoom: {
          ..._.get(state, 'dealRoom'),
          [dealRoomId]: {
            ..._.get(state, `dealRoom.[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights`),
              history: {
                ..._.get(state, `dealRoom.[${dealRoomId}].dealInsights.history`),
                loading: true,
              }
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_HISTORY_SUCCEEDED: {
      const { response, dealRoomId } = action.payload as FetchingDealRoomHistoryResponse;
      const { records, currentPage, totalPages, recordsPerPage } = response; 

      const existingItems = _.get(state, 'history.items') || [];
      let items = records || [];
      if (currentPage > 0) {
        items = [...existingItems, ...records];
      }

      return {
        ...state,
        dealRoom: {
          ..._.get(state, 'dealRoom'),
          [dealRoomId]: {
            ..._.get(state, `dealRoom[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom[${dealRoomId}].dealInsights`),
              history: {
                ..._.get(state, `dealRoom[${dealRoomId}].dealInsights.history`),
                items,
                loading: false,
                loaded: true,
                pagination: {
                  ..._.get(state, `dealRoom[${dealRoomId}].dealInsights.history.pagination`),
                  currentPage,
                  totalPages,
                  recordsPerPage,
                  hasMoreItems: currentPage < totalPages - 1
                }
              }
            }
          }
        }
      } 
    }

    case FETCHING_DEAL_ROOM_HISTORY_FAILED: {
      const { error, dealRoomId } = action.payload as FetchingDealRoomHistoryErrorResponse;
      return {
        ...state,
        dealRoom: {
          ..._.get(state, 'dealRoom'),
          [dealRoomId]: {
            ..._.get(state, `dealRoom[${dealRoomId}]`),
            dealInsights: {
              ..._.get(state, `dealRoom[${dealRoomId}].dealInsights`),
              history: {
                ..._.get(state, `dealRoom[${dealRoomId}].dealInsights.history`),
                loading: false,
                loaded: true,
                error
              }
            }
          }
        }
      }
    }

    case FETCH_DEAL_ROOM_SMARTCARDS:
      const { dealRoomId } = action.payload as FetchDealRoomSmartCardsRequest;
      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...state.dealRoom[dealRoomId],
            smartCards: {
              ...state.dealRoom[dealRoomId].smartCards,
              loading: true,
              loaded: false,
              error: null
            }
          }
        }
      }
    
    case FETCHING_DEAL_ROOM_SMARTCARDS_SUCCEEDED: {
      const { dealRoomId, response } = action.payload as FetchDealRoomSmartCardsResponse;
      return { 
        ...state,
        dealRoom:{
          ...state.dealRoom,
          [dealRoomId]: {
            ...state.dealRoom[dealRoomId],
            smartCards: {
              ...state.dealRoom[dealRoomId].smartCards,
              loading: false,
              loaded: true,
              error: null,
              items: response
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_SMARTCARDS_FAILED: {
      const { dealRoomId, error } = action.payload as FetchDealRoomSmartCardsErrorResponse;
      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...state.dealRoom[dealRoomId],
            smartCards: {
              ...state.dealRoom[dealRoomId].smartCards,
              loading: false,
              loaded: false,
              error
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_ASSET_ANALYTICS_SUCCEEDED: {
      const { dealRoomId, assetId, response } = action.payload as FetchDealRoomAssetAnalyticsResponse;
      const dealRoomState = state.dealRoom[dealRoomId];
      
      return {
        ...state,
        dealRoom:{
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoomState,
            assetAnalytics:{
              ...dealRoomState.assetAnalytics,
              [assetId]: response
            }
          }
        }
       
      }
    }

    case FETCH_DEAL_ROOM_EVENTS:{
      const { dealRoomId } = action.payload as FetchDealRoomEventsRequest;
      const dealRoomState = state.dealRoom[dealRoomId];

      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoomState,
            events: {
              ...dealRoomState.events,
              loading: true,
              loaded: false,
              error: null
            }
          }
        }
      }
    }

    case FETCHING_DEAL_ROOM_EVENTS_SUCCEEDED: {
      const { request, data, dealRoomId } =
        action.payload as FetchDealRoomEventsResponse;

      const dealRoomState = state.dealRoom[dealRoomId];

      if (!dealRoomState) {
        return state;
      }

      const currentPage = data.currentPage;
      const existingItems = _.get(dealRoomState, "events.items") || [];
      let records = data.records;
      if (currentPage > 0) {
        records = [...existingItems, ...records];
      }
      records = _.uniqBy(records, "id");


      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoomState,
            events: {
              loading: false,
              loaded: true,
              items: records,
              pagination: {
                currentPage: data.currentPage,
                totalPages: data.totalPages,
                recordsPerPage: data.recordsPerPage,
                totalRecordsCount: data.totalRecordsCount,
              },
            },
          }
        }
      }

    }
    case FETCHING_DEAL_ROOM_EVENTS_FAILED: {
      const { dealRoomId, error } = action.payload as FetchDealRoomEventsErrorResponse;

      const dealRoomState = state.dealRoom[dealRoomId];
      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [dealRoomId]: {
            ...dealRoomState,
            events: {
              ...dealRoomState.events,
              loading: false,
              loaded: false,
              error: error
            }
          }
        }
      }
    }

    case CLONE_DEAL_ROOM: {
      return {
        ...state,
        creation: {
          ...initialDealRoomCreationState,
          creating: true
        }
      }
    }

    case CLONING_DEAL_ROOM_SUCCEEDED: {
      const { response } = action.payload as CreateDealRoomResponse;
      const creationState = state.creation;
      if (!creationState) {
        return state;
      }

      return {
        ...state,
        creation: {
          ...creationState,
          creating: false,
          created: true,
          item: response,
          error: null
        }
      }
    }

    case CLONING_DEAL_ROOM_FALIED: {
      const { error } = action.payload as CreateDealRoomErrorResponse;
      const creationState = state.creation;
      if (!creationState) {
        return state;
      }

      return {
        ...state,
        creation: {
          ...creationState,
          creating: false,
          created: true,
          error: error
        }
      }
    }

    case MARK_DEAL_ROOM_AS_TEMPLATE: {
      const { id } = action.payload as DealRoomMarkAsTemplateRequest;

      let dealRoomState = state.dealRoom[id];

      if(!id || !dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [id]: {
            ...dealRoomState,
            template: {
              ..._.get(dealRoomState, "template", {
                loading: false, 
                error: null
              }),
              loading: true,
            }
          }
        }
      }
    }
  
    case MARKING_DEAL_ROOM_AS_TEMPLATE_SUCCEEDED: {
      const response = action.payload as DealRoomMarkAsTemplateResponse;

      if (!response) {
        return state;
      }

      let dealRoomState = state.dealRoom[response.id];

      if (!dealRoomState) {
        return state;
      }

      return {
        ...state,
        dealRoom: {
          ...state.dealRoom,
          [response.id]: {
            ...dealRoomState,
            item: {
              ...dealRoomState.item,
              template: _.get(response, "template", false),
            },
            template: {
               loading: false,
               error: null,
            },
          },
        },
      };
    }

  case MARKING_DEAL_ROOM_AS_TEMPLATE_FAILED: {
    const response = action.payload as DealRoomMarkAsTemplateErrorResponse;
    
    const dealRoomState = state.dealRoom[response.id];

    if (!dealRoomState) {
      return state;
    }

    return {
      ...state,
      dealRoom: {
        ...state.dealRoom,
        [response.id]: {
          ...dealRoomState,
          template: {
            loading: false,
            error: response.error,
          },
        },
      },
    };
  }

    default: {
      return state
    }
  }
}